import React, { useEffect, useState } from "react";

import { combineClasses, format } from "@kikoff/utils/src/string";

import styles from "./utilization_meter.module.scss";

export const getUtilizationTier = (percentage) =>
  ({
    true: { color: "#DF2114", label: "Very Poor" },
    [`${percentage < 75}`]: { color: "#D0712E", label: "Poor" },
    [`${percentage < 50}`]: { color: "#FEB72B", label: "Fair" },
    [`${percentage < 30}`]: { color: "#83BD54", label: "Good" },
    [`${percentage < 10}`]: { color: "#27AE60", label: "Excellent" },
  }.true);

interface UtilizationMeterProps {
  balance: number;
  limit: number;
  className?: string;
}

const UtilizationMeter: React.FC<UtilizationMeterProps> = ({
  balance,
  limit,
  className,
}) => {
  const [percent, setPercent] = useState(0);
  const tier = getUtilizationTier(percent);

  useEffect(() => {
    setPercent(Math.round((balance * 100) / limit));
  }, [balance, limit]);

  return (
    <div className={combineClasses(styles["utilization-meter"], className)}>
      <header>
        <div className={styles.label}>
          <div className={styles["rate-title"]}>Utilization Rate</div>
          {percent}% <span style={{ color: tier.color }}>{tier.label}</span>
        </div>
        <div className={`${styles.limit} text:regular+`}>
          {format.money(limit)}
        </div>
      </header>
      <div className={styles.track}>
        <div
          className={styles.bar}
          style={{ width: `${percent}%`, background: tier.color }}
        />
      </div>
    </div>
  );
};

export default UtilizationMeter;
